(function (root) {
"use strict";
function iniciar(n) {
var M = root.SudaderotasMotor;
if (!M || !M.pieza || !M.zonaSegura || !M.DISENOS) { if ((n || 0) < 300) setTimeout(function () { iniciar((n || 0) + 1); }, 25); return; }
if (M.zonaLlena) return;
var PW = M.PW, zOrig = M.zonaSegura, pOrig = M.pieza, libre = false;
function esGuia(pz) {
var p = pz && pz.pts;
return !!p && p.length === 8 && p[0][0] === 0 && p[0][1] === 0 && p[5][0] === pz.w && p[6][0] === pz.w && p[6][1] === pz.h && p[7][0] === 0 && p[7][1] === pz.h;
}
function llenar(pz, seg) {
var z = zOrig(pz, seg);
if (!z._o) z._o = { s: z.s, x: z.x, y: z.y, H: z.H, w: z.w, h: z.h };
var o = z._o, w = pz.w - 2 * seg, s = w / PW, h = pz.h - seg - o.y;
if (libre) { s = pz.w / PW; z.s = s; z.x = 0; z.y = 0; z.w = pz.w; z.h = pz.h; z.H = pz.h / s; return z; }
if (w > 0 && h > 0 && h / s > o.H) { z.s = s; z.x = seg; z.y = o.y; z.w = w; z.h = h; z.H = h / s; }
else { z.s = o.s; z.x = o.x; z.y = o.y; z.w = o.w; z.h = o.h; z.H = o.H; }
return z;
}
M.zonaSegura = function (pz, seg) { return esGuia(pz) ? llenar(pz, seg) : zOrig(pz, seg); };
/* arriba del cuello: solo en diseños sin arte de sobra se continúa la orilla en espejo; los que ya traen arte de sobra (tejidos, equipos, caritas) se ven completos sin repetir */
function sangra(estado) { var D = M.DISENOS[M.disenoDe(estado)]; return !!(D && (D.arteManga || D.equipo || D.sangra)); }
function hombros(c, pz, o, z) {
var k = o.pxmm, sg = o.sangrado || 0, Y0 = Math.round((sg + z.y) * k), S = Math.min(Y0, Math.round(3 * k));
if (S < 2 || Y0 + S > c.height) return;
var t = document.createElement("canvas"); t.width = c.width; t.height = S;
t.getContext("2d").drawImage(c, 0, Y0, c.width, S, 0, 0, c.width, S);
var x = c.getContext("2d"); x.save();
for (var y = Y0, n = 0; y > 0; y -= S, n++) {
x.save();
if (n % 2 === 0) { x.translate(0, y); x.scale(1, -1); x.drawImage(t, 0, 0); }
else x.drawImage(t, 0, y - S);
x.restore();
}
x.restore();
}
/* textos de la espalda: si el cliente escribió «Texto de la espalda», va ese texto; si lo dejó vacío (o no hay nombres), la espalda va sin texto.
   Un espacio invisible ocupa el lugar del nombre para que ningún diseño ponga «Mi mascota» u otro texto de relleno. */
var VACIO = "​";
function deEspalda(estado) {
if (!estado || estado._esp) return estado;
var ms = (estado.mascotas || []).length ? estado.mascotas : [{}], t = typeof estado.espalda === "string" ? estado.espalda.trim() : null;
var hay = ms.slice(0, estado.cantidad || 1).some(function (m) { return (m.nombre || "").trim(); });
if (t === null && hay) return estado;
var nuevo = ms.map(function (m, i) { return Object.assign({}, m, { nombre: i ? (t === null ? m.nombre : "") : (t === null ? (m.nombre || "").trim() || VACIO : t || VACIO) }); });
return Object.assign({}, estado, { mascotas: nuevo, _esp: true });
}
M.deEspalda = deEspalda;
function envolver() {
if (M.mockup && !M.mockup._esp) { var mk = M.mockup; M.mockup = function (cv, estado, fotos, lado) { return mk.call(this, cv, lado === "espalda" ? deEspalda(estado) : estado, fotos, lado); }; M.mockup._esp = true; }
if (M.panel && !M.panel._esp) { var pn = M.panel; M.panel = function (estado, fotos, px, lado) { return pn.call(this, lado === "espalda" ? deEspalda(estado) : estado, fotos, px, lado); }; M.panel._esp = true; }
}
envolver(); var vueltas = 0, iv = setInterval(function () { envolver(); if (++vueltas > 60) clearInterval(iv); }, 250);
M.pieza = function (estado, fotos, pz, o) {
libre = !!(estado && M.disenoDe(estado) === "foto");
var nm = pz && pz.nombre, ref = nm === "bolsa" ? o && o.frente : pz, z = null;
try { if ((nm === "frente" || nm === "espalda" || nm === "bolsa") && esGuia(ref)) z = llenar(ref, o.segura); } catch (e) {}
var c = pOrig.apply(this, nm === "espalda" ? [deEspalda(estado), fotos, pz, o] : arguments);
try { if (z && !libre && nm !== "bolsa" && z.y > o.segura + .5 && !sangra(estado)) hombros(c, pz, o, z); } catch (e) {}
return c;
};
M.zonaLlena = true;
/* «Casita de jengibre»: en prendas muy largas (sudaderota) el arte crecía más ancho que la prenda y el nombre se cortaba */
function jengibre(n) {
var D = M.DISENOS.jengibre;
if (!D || !D.panel) { if (n < 400) setTimeout(function () { jengibre(n + 1); }, 25); return; }
if (D._tope) return;
var p0 = D.panel;
D.panel = function (ctx, estado, fotos, H, lado) {
if (H <= 1300) return p0.apply(this, arguments);
var Hc = 1300, f = H > 1500 ? .8 : 1;
ctx.save(); ctx.translate(PW / 2 * (1 - f), (H - Hc * f) * .6); ctx.scale(f, f);
try { return p0.call(this, ctx, estado, fotos, Hc, lado); } finally { ctx.restore(); }
};
D._tope = true;
try { root.dispatchEvent(new Event("sdr-arte-listo")); } catch (e) {}
}
jengibre(0);
if (!M.DISENOS.foto) M.DISENOS.foto = {
nombre: "Tu foto tal cual", max: 1, libre: true,
fondoFn: function (ctx, estado, w, h) { ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, w, h); },
panel: function (ctx, estado, fotos, H, lado) {
if (lado === "espalda") return;
var im = fotos && fotos[0];
if (!im) {
ctx.save(); ctx.fillStyle = "#eef3f1"; ctx.fillRect(0, 0, PW, H);
ctx.strokeStyle = "#9fb3ab"; ctx.lineWidth = 10; ctx.setLineDash([36, 24]); ctx.strokeRect(40, 40, PW - 80, H - 80);
ctx.fillStyle = "#7d958c"; ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.font = "800 96px sans-serif";
ctx.fillText("TU FOTO", PW / 2, H / 2 - 60); ctx.fillText("AQUÍ", PW / 2, H / 2 + 60); ctx.restore();
return;
}
var iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height;
if (!iw || !ih) return;
var k = (estado.ajuste === "completa" ? Math.min : Math.max)(PW / iw, H / ih), w = iw * k, h = ih * k;
ctx.drawImage(im, (PW - w) / 2, (H - h) / 2, w, h);
}
};
try { root.dispatchEvent(new Event("sdr-arte-listo")); } catch (e) {}
}
iniciar(0);
})(this);
